const initialState = {
   tags: [],
   tagsIsFetching: true,
};

export default initialState;
